import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  Asset } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../secure-zone-api-endpoints';


interface GetAssetsResponse {
  assets: Asset[];
}

interface GetAssetResponse {
  asset: Asset;
}

export interface ZoneMappingRequest {
  zoneId: string;
  assetIds: string[];
  environmentIds: string[];
}

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

   getAssets(currentPage: number): Observable<Asset[]> {
      return this.http.post<GetAssetsResponse>(`${this.apiUrl}${API_ENDPOINTS.SECUREZONEASSET.FETCH}`, { currentPage })
        .pipe(
          map(response => response.assets),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }
  
  
    getAssetsSearch(currentPage: number, searchText: String, filterByHeader: String): Observable<Asset[]> {
      return this.http.post<GetAssetsResponse>(`${this.apiUrl}${API_ENDPOINTS.SECUREZONEASSET.SEARCH}`, { currentPage, searchText, filterByHeader })
        .pipe(
          map(response => response.assets),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }

}